// First non-empty string from untyped record payloads (GeoJSON properties,
// staged rows) whose values arrive as `unknown`. Returns "" when nothing
// qualifies, so it also replaces `String(a || b || "")` chains that would
// otherwise render "[object Object]" for corrupt non-string values.
export function firstString(...values: unknown[]): string {
  for (const value of values) {
    if (typeof value === "string" && value !== "") return value;
  }
  return "";
}
